module.exports = __webpack_public_path__ + "img/img13.519253ba.png";